// src/pages/dashboard/user/pagamentosUser.js
import React, { useEffect, useState } from "react";
import {
    Button,
    Modal,
    Table,
    Alert,
    Row,
    Col,
    Card,
    InputGroup,
} from "@themesberg/react-bootstrap";
import moment from "moment";

export default function PagamentosUser() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");

    // Data
    const [pagamentos, setPagamentos] = useState([]);
    const [praticantes, setPraticantes] = useState([]);
    const [pagamentoPraticantes, setPagamentoPraticantes] = useState([]);

    const [search, setSearch] = useState("");
    const [orderBy, setOrderBy] = useState("data_limite");
    const [orderDir, setOrderDir] = useState("asc");
    const [showPast, setShowPast] = useState(false);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    // Modal
    const [showModal, setShowModal] = useState(false);
    const [modalPayment, setModalPayment] = useState(null);
    const [modalList, setModalList] = useState([]);

    const [modalSearch, setModalSearch] = useState("");

    const authHeaders = () => ({ Authorization: `Bearer ${token}` });

    useEffect(() => {
        loadAll();
    }, []);

    const loadAll = async () => {
        setLoading(true);
        setError("");
        try {
            const [resP, resPr, resPP] = await Promise.all([
                fetch(`${API_BASE_URL}/Pagamentos`, { headers: authHeaders() }),
                fetch(`${API_BASE_URL}/Praticantes`, { headers: authHeaders() }),
                fetch(`${API_BASE_URL}/PagamentoPraticantes`, { headers: authHeaders() }),
            ]);

            setPagamentos(resP.ok ? await resP.json() : []);
            const pr = resPr.ok ? await resPr.json() : [];
            setPraticantes(pr.filter((p) => p.isAtivo === 1 || p.isAtivo === true));
            setPagamentoPraticantes(resPP.ok ? await resPP.json() : []);
        } catch (err) {
            console.error(err);
            setError("Erro ao carregar dados.");
        } finally {
            setLoading(false);
        }
    };

    const getCounts = (pagamentoId) => {
        const assoc = pagamentoPraticantes.filter(
            (pp) => pp.pagamentoId === pagamentoId && praticantes.some(p => p.id === pp.praticanteId)
        );
        const total = assoc.length;
        const paid = assoc.filter((a) => a.isPago === 1 || a.isPago === true).length;
        return { total, paid };
    };

    const openModal = (p) => {
        setModalPayment(p);
        const list = pagamentoPraticantes
            .filter((pp) => pp.pagamentoId === p.id)
            .map((a) => ({
                praticante: praticantes.find((pr) => pr.id === a.praticanteId) || { id: a.praticanteId, nome: "N/A" },
                isPago: a.isPago === 1 || a.isPago === true,
            }));
        setModalList(list);
        setModalSearch("");
        setShowModal(true);
    };

    const modalFiltered = modalList.filter((x) =>
        x.praticante.nome.toLowerCase().includes(modalSearch.toLowerCase())
    );

    return (
        <>
            <div className="py-4">
                <h1 className="font-anton">Pagamentos Disponíveis</h1>
                <p className="font-open-sans mb-0">
                    Consulte todos os pagamentos associados e o seu estado.
                </p>
            </div>

            {error && (
                <Alert variant="danger" onClose={() => setError("")} dismissible>
                    {error}
                </Alert>
            )}

            {/* Filtros mobile-first */}
            <Row className="mb-3 g-2 align-items-center">
                <Col xs={12} sm={5}>
                    <input
                        className="form-control"
                        placeholder="Pesquisar por nome..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </Col>
                <Col xs={7} sm={4}>
                    <select
                        className="form-select"
                        value={orderDir}
                        onChange={(e) => setOrderDir(e.target.value)}
                    >
                        <option value="asc">Mais antigo primeiro</option>
                        <option value="desc">Mais recente primeiro</option>
                    </select>
                </Col>
                <Col xs={5} sm={3} className="d-flex align-items-center gap-2">
                    <input
                        type="checkbox"
                        className="form-check-input m-0"
                        id="showPastCheck"
                        checked={showPast}
                        onChange={() => setShowPast(!showPast)}
                    />
                    <label htmlFor="showPastCheck" className="form-check-label small mb-0">
                        Mostrar expirados
                    </label>
                </Col>
            </Row>

            {/* Tabela — apenas em md+ */}
            <div className="d-none d-md-block">
                <Card className="shadow-sm mb-4">
                    <Card.Body>
                        <Table responsive hover>
                            <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Valor (€)</th>
                                <th>Data Limite</th>
                                <th>Estado</th>
                                <th>Ações</th>
                            </tr>
                            </thead>
                            <tbody>
                            {pagamentos
                                .filter(p => {
                                    const nomeMatch = p.pagamento?.toLowerCase().includes(search.toLowerCase());
                                    const isFuture = moment(p.data_limite).isSameOrAfter(moment());
                                    return nomeMatch && (showPast || isFuture);
                                })
                                .sort((a, b) => {
                                    const dateA = moment(a.data_limite);
                                    const dateB = moment(b.data_limite);
                                    if (dateA.isBefore(dateB)) return orderDir === "asc" ? -1 : 1;
                                    if (dateA.isAfter(dateB)) return orderDir === "asc" ? 1 : -1;
                                    return 0;
                                })
                                .map((p) => {
                                    const counts = getCounts(p.id);
                                    const allPaid = counts.total > 0 && counts.total === counts.paid;
                                    const isExpired = moment(p.data_limite).isBefore(moment());
                                    return (
                                        <tr key={p.id}>
                                            <td className="fw-bold">{p.pagamento}</td>
                                            <td>{Number(p.valor).toFixed(2)} €</td>
                                            <td className={isExpired ? "text-danger" : ""}>
                                                {p.data_limite ? moment(p.data_limite).format("DD/MM/YYYY") : "-"}
                                            </td>
                                            <td>
                                                <span className={`badge ${allPaid ? "bg-success" : "bg-danger"}`}>
                                                    {allPaid ? "✓ Pago" : "✗ Não Pago"}
                                                </span>
                                            </td>
                                            <td>
                                                <Button size="sm" variant="outline-primary" onClick={() => openModal(p)}>
                                                    Ver detalhes
                                                </Button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </div>

            {/* Cards — apenas em mobile */}
            <div className="d-md-none">
                {pagamentos
                    .filter(p => {
                        const nomeMatch = p.pagamento?.toLowerCase().includes(search.toLowerCase());
                        const isFuture = moment(p.data_limite).isSameOrAfter(moment());
                        return nomeMatch && (showPast || isFuture);
                    })
                    .sort((a, b) => {
                        const dateA = moment(a.data_limite);
                        const dateB = moment(b.data_limite);
                        if (dateA.isBefore(dateB)) return orderDir === "asc" ? -1 : 1;
                        if (dateA.isAfter(dateB)) return orderDir === "asc" ? 1 : -1;
                        return 0;
                    })
                    .map((p) => {
                        const counts = getCounts(p.id);
                        const allPaid = counts.total > 0 && counts.total === counts.paid;
                        const isExpired = moment(p.data_limite).isBefore(moment());
                        return (
                            <Card key={p.id} className="mb-3 shadow-sm">
                                <Card.Body>
                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                        <h6 className="fw-bold mb-0 me-2">{p.pagamento}</h6>
                                        <span className={`badge flex-shrink-0 ${allPaid ? "bg-success" : "bg-danger"}`}>
                                            {allPaid ? "✓ Pago" : "✗ Não Pago"}
                                        </span>
                                    </div>

                                    <div className="d-flex flex-wrap gap-3 mb-3">
                                        <div>
                                            <div className="small text-muted">Valor</div>
                                            <div className="fw-bold fs-5">{Number(p.valor).toFixed(2)} €</div>
                                        </div>
                                        <div>
                                            <div className="small text-muted">Data Limite</div>
                                            <div className={`fw-semibold ${isExpired ? "text-danger" : ""}`}>
                                                {p.data_limite ? moment(p.data_limite).format("DD/MM/YYYY") : "—"}
                                                {isExpired && <span className="ms-1 small">(Expirado)</span>}
                                            </div>
                                        </div>
                                        <div>
                                            <div className="small text-muted">Praticantes</div>
                                            <div className="fw-semibold">
                                                <span className="text-success">{counts.paid}</span>
                                                <span className="text-muted"> / {counts.total} pagos</span>
                                            </div>
                                        </div>
                                    </div>

                                    <Button
                                        variant="outline-primary"
                                        size="sm"
                                        className="w-100"
                                        onClick={() => openModal(p)}
                                    >
                                        Ver detalhes dos praticantes
                                    </Button>
                                </Card.Body>
                            </Card>
                        );
                    })}
                {pagamentos.filter(p => {
                    const nomeMatch = p.pagamento?.toLowerCase().includes(search.toLowerCase());
                    const isFuture = moment(p.data_limite).isSameOrAfter(moment());
                    return nomeMatch && (showPast || isFuture);
                }).length === 0 && (
                    <p className="text-center text-muted py-4">Nenhum pagamento encontrado.</p>
                )}
            </div>

            {/* Modal praticantes — redesenhado para mobile */}
            <Modal size="md" show={showModal} centered onHide={() => setShowModal(false)}>
                <Modal.Header closeButton className="border-bottom">
                    <div>
                        <Modal.Title className="h5 mb-0">{modalPayment?.pagamento}</Modal.Title>
                        {modalPayment && (
                            <div className="small text-muted mt-1">
                                {Number(modalPayment.valor).toFixed(2)} € · Limite: {moment(modalPayment.data_limite).format("DD/MM/YYYY")}
                            </div>
                        )}
                    </div>
                </Modal.Header>
                <Modal.Body className="p-0">
                    {/* Resumo do pagamento */}
                    {modalList.length > 0 && (
                        <div className="px-3 py-2 bg-light border-bottom d-flex gap-4">
                            <div className="text-center">
                                <div className="fw-bold text-success fs-5">
                                    {modalList.filter(x => x.isPago).length}
                                </div>
                                <div className="small text-muted">Pagos</div>
                            </div>
                            <div className="text-center">
                                <div className="fw-bold text-danger fs-5">
                                    {modalList.filter(x => !x.isPago).length}
                                </div>
                                <div className="small text-muted">Por pagar</div>
                            </div>
                            <div className="text-center">
                                <div className="fw-bold fs-5">{modalList.length}</div>
                                <div className="small text-muted">Total</div>
                            </div>
                        </div>
                    )}

                    {/* Pesquisa dentro do modal */}
                    <div className="px-3 py-2 border-bottom">
                        <input
                            className="form-control form-control-sm"
                            placeholder="Pesquisar praticante..."
                            value={modalSearch}
                            onChange={(e) => setModalSearch(e.target.value)}
                        />
                    </div>

                    {/* Lista de praticantes */}
                    <div style={{ maxHeight: "55vh", overflowY: "auto" }}>
                        {modalFiltered.length === 0 ? (
                            <p className="text-center text-muted py-4">Nenhum praticante encontrado.</p>
                        ) : (
                            <div className="list-group list-group-flush">
                                {modalFiltered.map((item, idx) => (
                                    <div
                                        key={idx}
                                        className="list-group-item d-flex align-items-center justify-content-between py-3 px-3"
                                    >
                                        <div className="d-flex align-items-center gap-2">
                                            {/* Ícone de estado */}
                                            <div
                                                style={{
                                                    width: 32,
                                                    height: 32,
                                                    minWidth: 32,
                                                    borderRadius: "50%",
                                                    backgroundColor: item.isPago ? "#d1fae5" : "#fee2e2",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    fontSize: 14,
                                                }}
                                            >
                                                {item.isPago ? "✓" : "✗"}
                                            </div>
                                            <span className="fw-semibold">{item.praticante.nome}</span>
                                        </div>
                                        <span
                                            className="badge flex-shrink-0"
                                            style={{
                                                backgroundColor: item.isPago ? "#d1fae5" : "#fee2e2",
                                                color: item.isPago ? "#065f46" : "#991b1b",
                                                padding: "5px 10px",
                                                borderRadius: 20,
                                                fontSize: 12,
                                                fontWeight: 600,
                                            }}
                                        >
                                            {item.isPago ? "Pago" : "Não Pago"}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="w-100 w-sm-auto" onClick={() => setShowModal(false)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}